import {dateToPersian} from "../../../system/utils";

// Pure helpers of the "my work" activity tab (kept apart from the component so they are easy to test).

const SNOOZE_HOURS = [8, 10, 12, 14, 16, 17];
export const toPersianDigits = (value) => String(value).replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[digit]);

function sameDay(a, b) {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function dueLabel(dueDate, now = new Date()) {
    if (!dueDate) return "بدون سررسید";
    const due = new Date(dueDate);
    const time = toPersianDigits(`${String(due.getHours()).padStart(2, "0")}:${String(due.getMinutes()).padStart(2, "0")}`);
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);
    if (sameDay(due, now)) return `امروز ساعت ${time}`;
    if (sameDay(due, tomorrow)) return `فردا ساعت ${time}`;
    if (sameDay(due, yesterday)) return `دیروز ساعت ${time}`;
    return `${dateToPersian(due, "D MMMM")} ساعت ${time}`;
}

export function atHour(base, hour, minute = 0) {
    const date = new Date(base);
    date.setHours(hour, minute, 0, 0);
    return date;
}

// the snooze choices of the popup: today's two-hour slots, tomorrow and the start of next week (Saturday)
export function snoozeChoices(task, now = new Date()) {
    const due = task?.dueDate ? new Date(task.dueDate) : null;
    const minimum = Math.max(now.getTime(), due ? due.getTime() : 0);
    const keepTime = (date) => (due ? atHour(date, due.getHours(), due.getMinutes()) : atHour(date, 9));
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    const nextWeek = new Date(now);
    const daysToSaturday = ((6 - now.getDay()) + 7) % 7 || 7;
    nextWeek.setDate(now.getDate() + daysToSaturday);
    return {
        today: SNOOZE_HOURS.map((hour) => {
            const value = atHour(now, hour);
            return {hour, value, disabled: value.getTime() <= minimum};
        }),
        tomorrow: keepTime(tomorrow),
        nextWeek: atHour(nextWeek, 9),
        // a snooze always moves the due date later (the backend refuses earlier dates)
        tomorrowDisabled: keepTime(tomorrow).getTime() <= minimum,
        nextWeekDisabled: atHour(nextWeek, 9).getTime() <= minimum,
        // a custom day keeps the due time, so the first allowed day is the one after the due date
        firstCustomDay: new Date(due && due.getTime() >= now.getTime() ? due.getTime() + 24 * 60 * 60 * 1000 : now.getTime()),
    };
}
